import { render, staticRenderFns } from "./ApiMh.vue?vue&type=template&id=34775333&scoped=true"
import script from "./ApiMh.vue?vue&type=script&lang=js"
export * from "./ApiMh.vue?vue&type=script&lang=js"
import style0 from "./ApiMh.vue?vue&type=style&index=0&id=34775333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34775333",
  null
  
)

export default component.exports